import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.immediate";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import { AlignBox } from "../Align";
import Box from "../Box";
import { UnstyledLink } from "../UnstyledLink";
import Icon from "../Icon";
import { cancelCircle, search } from "../Icon/Assets";
import Input from "./";
import { InputBaseContext } from "./InputBase";
import { InputGroupContext } from "./InputGroup";
import { PressableContext, PressableCore, PressableField } from "../Pressable";
import { Text } from "../Text";
import FocusHandler from "../handler/FocusHandler";
import HoverHandler from "../handler/HoverHandler";

var TextInputStartEnd = /*#__PURE__*/function (_React$Component) {
  _inherits(TextInputStartEnd, _React$Component);

  var _super = _createSuper(TextInputStartEnd);

  function TextInputStartEnd() {
    _classCallCheck(this, TextInputStartEnd);

    return _super.apply(this, arguments);
  }

  _createClass(TextInputStartEnd, [{
    key: "_getHorizontalPadding",
    value: function _getHorizontalPadding(size) {
      if (size === 'jumbo') {
        return 12;
      } else if (size === 'small') {
        return 4;
      }

      return 8;
    }
  }, {
    key: "getVerticalPadding",
    value: function getVerticalPadding(size) {
      return size === 'jumbo' ? 8 : 4;
    }
  }, {
    key: "getPadding",
    value: function getPadding(size) {
      var side = this.props.side;
      return side === 'start' ? {
        left: this._getHorizontalPadding(size),
        vertical: this.getVerticalPadding(size)
      } : {
        right: this._getHorizontalPadding(size),
        vertical: this.getVerticalPadding(size)
      };
    }
  }, {
    key: "getTextProps",
    value: function getTextProps(fontLineHeight, fontSize) {
      return {
        lineHeight: fontLineHeight,
        size: fontSize
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ariaLabel = _this$props['aria-label'],
          color = _this$props.color,
          content = _this$props.content,
          disabled = _this$props.disabled,
          fontLineHeight = _this$props.fontLineHeight,
          fontSize = _this$props.fontSize,
          onClick = _this$props.onClick,
          size = _this$props.size;
      return /*#__PURE__*/React.createElement(UnstyledLink, {
        className: "TextInput-start",
        "aria-label": ariaLabel,
        disabled: disabled,
        onClick: onClick,
        tabIndex: "-1",
        type: "button"
      }, /*#__PURE__*/React.createElement(AlignBox, {
        reference: this.getTextProps(fontLineHeight, fontSize),
        padding: this.getPadding(size)
      }, /*#__PURE__*/React.createElement(Text, _extends({
        color: color
      }, this.getTextProps(fontLineHeight, fontSize), {
        wrap: false
      }), content)));
    }
  }]);

  return TextInputStartEnd;
}(React.Component);

var TextInput = /*#__PURE__*/function (_React$Component2) {
  _inherits(TextInput, _React$Component2);

  var _super2 = _createSuper(TextInput);

  function TextInput() {
    var _this;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));
    _this.input = void 0;

    _this.inputRef = function (input) {
      _this.input = input;
    };

    _this.handleFocus = function () {
      _this.input && _this.input.focus();
    };

    return _this;
  }

  _createClass(TextInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoFocus) {
        setImmediate(function () {
          return _this2.input && _this2.input.focus();
        });
      }
    }
  }, {
    key: "node",
    value: function node() {
      return this.input ? this.input.node() : null;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input && this.input.focus();
    }
  }, {
    key: "select",
    value: function select() {
      this.input && this.input.select();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input && this.input.blur();
    }
  }, {
    key: "getVerticalPadding",
    value: function getVerticalPadding(sizeValue) {
      return sizeValue === 'jumbo' ? 8 : 4;
    }
  }, {
    key: "getClearMargin",
    value: function getClearMargin(sizeValue) {
      return sizeValue === 'large' ? 2 : 0;
    }
  }, {
    key: "getClearPadding",
    value: function getClearPadding(sizeValue) {
      if (sizeValue === 'jumbo') {
        return 8;
      } else if (sizeValue === 'large') {
        return 4;
      } else if (sizeValue === 'small') {
        return 0;
      }

      return 2;
    }
  }, {
    key: "getIconMargin",
    value: function getIconMargin(sizeValue) {
      if (sizeValue === 'large') {
        return {
          left: 2
        };
      } else if (sizeValue === 'small') {
        return {
          left: 2
        };
      }

      return null;
    }
  }, {
    key: "getIconPadding",
    value: function getIconPadding(sizeValue) {
      if (sizeValue === 'jumbo') {
        return {
          left: 12,
          vertical: this.getVerticalPadding(sizeValue)
        };
      } else if (sizeValue === 'small') {
        return {
          left: 4,
          vertical: this.getVerticalPadding(sizeValue)
        };
      }

      return {
        left: 8,
        vertical: this.getVerticalPadding(sizeValue)
      };
    } // $FlowFixMeTypesFirst

  }, {
    key: "_getWidth",
    value: function _getWidth(widthValue) {
      if (widthValue === 'quantity') {
        return 40;
      } else if (widthValue === 'ssn') {
        return 120;
      } else if (widthValue === 'zip') {
        return 100;
      }

      return widthValue;
    }
  }, {
    key: "renderSearchIcon",
    value: function renderSearchIcon(color, disabledValue, sizeValue) {
      return /*#__PURE__*/React.createElement(UnstyledLink, {
        className: "TextInput-search" // @TODO SAIL-908
        ,
        "aria-label": "Search for",
        disabled: disabledValue,
        onClick: this.handleFocus,
        tabIndex: "-1",
        type: "button"
      }, /*#__PURE__*/React.createElement(AlignBox, {
        className: "TextInput-icon",
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        margin: this.getIconMargin(sizeValue),
        padding: this.getIconPadding(sizeValue)
      }, /*#__PURE__*/React.createElement(Icon, {
        color: color,
        icon: search,
        size: 12
      })));
    }
  }, {
    key: "renderClear",
    value: function renderClear(sizeValue) {
      var _this3 = this;

      var onClear = this.props.onClear;
      return /*#__PURE__*/React.createElement(FocusHandler, {
        stopPropagation: true
      }, function (focusProps, inputMethod) {
        var isFocused = inputMethod !== null;
        return /*#__PURE__*/React.createElement(HoverHandler, null, function (hoverProps, isHovering) {
          return /*#__PURE__*/React.createElement(AlignBox, {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            margin: {
              right: _this3.getClearMargin(sizeValue)
            },
            padding: {
              right: _this3.getClearPadding(sizeValue)
            }
          }, /*#__PURE__*/React.createElement(UnstyledLink, _extends({}, focusProps, hoverProps, {
            className: "TextInput-clear",
            onClick: onClear,
            type: "button"
          }), /*#__PURE__*/React.createElement(PressableCore, {
            radius: "all",
            shadow: {
              focused: isFocused
            }
          }, /*#__PURE__*/React.createElement(Box, {
            margin: 2,
            padding: 4
          }, /*#__PURE__*/React.createElement(Icon, {
            color: isHovering ? 'dark' : 'gray300',
            icon: cancelCircle,
            size: 12
          }), /*#__PURE__*/React.createElement(Text, {
            visuallyHidden: true
          }, "Clear")))));
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement(InputBaseContext.Consumer, null, function (inputBaseContext) {
        return /*#__PURE__*/React.createElement(InputGroupContext.Consumer, null, function (inputGroupContext) {
          var _this4$props = _this4.props,
              ariaDescribedBy = _this4$props['aria-describedby'],
              ariaLabel = _this4$props['aria-label'],
              ariaLabelledBy = _this4$props['aria-labelledby'],
              align = _this4$props.align,
              autocorrectPattern = _this4$props.autocorrectPattern,
              className = _this4$props.className,
              clearable = _this4$props.clearable,
              disabled = _this4$props.disabled,
              end = _this4$props.end,
              ghost = _this4$props.ghost,
              id = _this4$props.id,
              invalid = _this4$props.invalid,
              nested = _this4$props.nested,
              max = _this4$props.max,
              maxLength = _this4$props.maxLength,
              multiline = _this4$props.multiline,
              name = _this4$props.name,
              onClear = _this4$props.onClear,
              placeholder = _this4$props.placeholder,
              radius = _this4$props.radius,
              readOnly = _this4$props.readOnly,
              required = _this4$props.required,
              size = _this4$props.size,
              start = _this4$props.start,
              inputGroupContextStyle = _this4$props.style,
              type = _this4$props.type,
              value = _this4$props.value,
              width = _this4$props.width,
              remaining = _objectWithoutProperties(_this4$props, ["aria-describedby", "aria-label", "aria-labelledby", "align", "autocorrectPattern", "className", "clearable", "disabled", "end", "ghost", "id", "invalid", "nested", "max", "maxLength", "multiline", "name", "onClear", "placeholder", "radius", "readOnly", "required", "size", "start", "style", "type", "value", "width"]);

          var disabledValue = inputBaseContext && inputBaseContext.disabled || inputGroupContext && inputGroupContext.disabled || disabled;
          var invalidValue = inputBaseContext && inputBaseContext.invalid || inputGroupContext && inputGroupContext.invalid || invalid;
          var ghostValue = inputBaseContext && inputBaseContext.ghost || ghost;
          var radiusValue = inputBaseContext && inputBaseContext.radius || inputGroupContext && inputGroupContext.radius || radius;
          var sizeValue = inputBaseContext && inputBaseContext.size || inputGroupContext && inputGroupContext.size || size;
          var widthValue = inputGroupContext && inputGroupContext.width || width;
          var classes = classNames('TextInput', inputBaseContext.inputBaseClassName, inputGroupContext.inputGroupClassName, className, {
            'Is--clearable': clearable,
            'Is--invalid': invalidValue,
            'Is--readOnly': readOnly
          });
          return /*#__PURE__*/React.createElement(FocusHandler, null, function (focusProps, inputMethod) {
            var isFocused = inputMethod !== null;
            return /*#__PURE__*/React.createElement(HoverHandler, null, function (hoverProps, isHovering) {
              return /*#__PURE__*/React.createElement(PressableField, _extends({}, focusProps, hoverProps, {
                className: classes,
                disabled: disabledValue,
                focused: isFocused,
                ghost: ghostValue,
                hovered: isHovering,
                invalid: invalidValue,
                radius: radiusValue,
                size: sizeValue,
                width: _this4._getWidth(widthValue)
              }), /*#__PURE__*/React.createElement(PressableContext.Consumer, null, function (_ref) {
                var pressableContextClasses = _ref.pressableContextClasses,
                    color = _ref.color,
                    fontLineHeight = _ref.fontLineHeight,
                    fontSize = _ref.fontSize,
                    pressableContextStyle = _ref.style;
                var elementClasses = classNames('TextInput-element', {
                  'TextInput-element--align--center': align === 'center',
                  'TextInput-element--align--left': align === 'left',
                  'TextInput-element--align--right': align === 'right'
                }, pressableContextClasses);
                return /*#__PURE__*/React.createElement(React.Fragment, null, start && /*#__PURE__*/React.createElement(TextInputStartEnd, _extends({}, start, {
                  color: color,
                  disabled: disabledValue,
                  fontLineHeight: fontLineHeight,
                  fontSize: fontSize,
                  onClick: _this4.handleFocus,
                  side: "start",
                  size: sizeValue
                })), type === 'search' && _this4.renderSearchIcon(color, disabledValue, sizeValue), /*#__PURE__*/React.createElement(Input, _extends({}, remaining, {
                  className: elementClasses,
                  "aria-describedby": ariaDescribedBy,
                  "aria-invalid": invalidValue && 'true',
                  "aria-label": ariaLabel,
                  "aria-labelledby": ariaLabelledBy,
                  ref: _this4.inputRef,
                  autocorrectPattern: autocorrectPattern,
                  disabled: disabledValue,
                  readOnly: readOnly,
                  id: id,
                  max: max,
                  maxLength: maxLength,
                  multiline: multiline,
                  name: name,
                  placeholder: placeholder,
                  required: required,
                  style: _objectSpread({}, pressableContextStyle, inputGroupContextStyle),
                  type: type,
                  value: value
                })), clearable && value && _this4.renderClear(sizeValue), end && /*#__PURE__*/React.createElement(TextInputStartEnd, _extends({}, end, {
                  color: color,
                  disabled: disabledValue,
                  fontLineHeight: fontLineHeight,
                  fontSize: fontSize,
                  onClick: _this4.handleFocus,
                  side: "end",
                  size: sizeValue
                })));
              }));
            });
          });
        });
      });
    }
  }]);

  return TextInput;
}(React.Component);

TextInput.defaultProps = {
  align: 'left',
  disabled: false,
  ghost: false,
  invalid: false,
  nested: false,
  radius: 'all',
  size: 'medium',
  style: {},
  type: 'text',
  width: 'short'
};
export default TextInput;